import { stringify } from "query-string";

interface IQueryParams {
  fromDate: string;
  untilDate: string;
  adultsCount: number;
  children: number[];
}

export const transformToStringifiedQuery = (params: IQueryParams): string => {
  const queryParams = {
    fromDate: params.fromDate,
    untilDate: params.untilDate,
    adultsCount: params.adultsCount,
    ...(params.children.length > 0 && { children: params.children }),
  };

  return `?${stringify(queryParams)}`;
};
